// @ts-nocheck
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { DateRangePicker } from 'sonata-react-components';

import '../reportingSectionAdvancedFilter.scss';

import PropTypes from 'prop-types';

function AdvancedFilterDatePicker({ beginDate, endDate, maxDate, minDate, onChangeDatePicker, required = false }) {
  const format = taptap.app.i18n_dates.getDateLocalizations().shortDate;

  const [{ currentBeginDate, currentFinalDate, maxDateM, minDateM }, setState] = useState({
    currentBeginDate: beginDate,
    currentFinalDate: endDate,
    maxDateM: moment.utc(maxDate).endOf('day'),
    minDateM: moment.utc(minDate).startOf('day')
  });

  const onDatesChange = useCallback(dates => {
    const { endDate: newEndDate, startDate } = dates;
    const startDateFormat = startDate ? startDate.startOf('day').format('YYYY-MM-DD') : null;
    const endDateFormat = newEndDate ? newEndDate.startOf('day').format('YYYY-MM-DD') : null;
    setState(prevState => ({
      ...prevState,
      currentBeginDate: startDate,
      currentFinalDate: newEndDate
    }));
    onChangeDatePicker(startDateFormat, endDateFormat);
  }, []);

  useEffect(() => {
    setState(prevState => ({
      ...prevState,
      maxDateM: moment.utc(maxDate).endOf('day'),
      minDateM: moment.utc(minDate).startOf('day')
    }));
  }, [minDate, maxDate]);

  const isOutsideRange = date => {
    const fDate = date.endOf('day');
    return fDate.isBefore(minDateM) || fDate.isAfter(maxDateM);
  };

  const numberOfMonth = useMemo(() => {
    const minDateMonth = minDateM.month();
    const maxDateMonth = maxDateM.month();
    return minDateMonth === maxDateMonth ? 1 : 2;
  }, [minDateM, maxDateM]);

  return (
    <DateRangePicker
      displayFormat={format}
      endDate={currentFinalDate ? moment.utc(currentFinalDate) : null}
      endDateId="advancedFilterDatePicker_endDate"
      endDatePlaceholderText="to"
      initialVisibleMonth={() => minDateM}
      isOutsideRange={isOutsideRange}
      maxDate={maxDateM}
      minDate={minDateM}
      minimumNights={0}
      numberOfMonths={numberOfMonth}
      onDatesChange={onDatesChange}
      required={required}
      showClearDates={false}
      startDate={currentBeginDate ? moment.utc(currentBeginDate) : null}
      startDateId="advancedFilterDatePicker_beginDate"
      startDatePlaceholderText="From"
    />
  );
}

AdvancedFilterDatePicker.propTypes = {
  beginDate: PropTypes.string,
  endDate: PropTypes.string,
  maxDate: PropTypes.string,
  minDate: PropTypes.string,
  onChangeDatePicker: PropTypes.func,
  required: PropTypes.bool
};

export default AdvancedFilterDatePicker;
